import { ActionIcon } from "@mantine/core";
import { getPermission } from "../../functions/utilFunctions";
import { useUIStore } from "../../stores/UIStore";
import { IconChevronRight, IconX } from "@tabler/icons-react";

const NavbarToggler = ({ ...props }) => {
  const campaignOpened = useUIStore((s) => s.campaignOpened);
  const setCampaignOpened = useUIStore((s) => s.setCampaignOpened);
  const navbarClosed = useUIStore((s) => s.navbarClosed);
  const setNavbarClosed = useUIStore((s) => s.setNavbarClosed);

  const toggleNavbar = () => {
    if (campaignOpened) {
      setCampaignOpened(false);
    }
    setNavbarClosed(!navbarClosed);
  };

  if (getPermission("displaySideMenu")) {
    return (
      <ActionIcon
        onClick={toggleNavbar}
        radius={16}
        variant="subtle"
        h={48}
        w={48}
        {...props}
      >
        {navbarClosed ? (
          <IconChevronRight size={28} style={{ strokeWidth: 1.1 }} />
        ) : (
          <IconX size={28} style={{ strokeWidth: 1.1 }} />
        )}
      </ActionIcon>
    );
  }
  return;
};

export default NavbarToggler;
